'use client';

import { DRIFT_TOKEN_BANK_INDEX } from 'src/environmentVariables/EnvironmentVariables';
import AccountsTable from 'src/components/PortfolioPage/PortfolioAccountsSubPage/AccountsTable/AccountsTable';
import Button from 'src/components/primitives/Button/Button';
import { Add } from '@drift-labs/icons';
import useModal from 'src/components/Modals/hooks/useModal';
import { MyVaultPositionsContent } from 'src/components/Vaults/VaultsTables/MyVaultPositionsTable';
import { InsuranceFundList } from 'src/components/Vaults/InsuranceFundVaults/lists/InsuranceFundList';
import usePortfolioAccountsData from 'src/components/PortfolioPage/PortfolioAccountsSubPage/hooks/usePortfolioAccountsData';
import { noop } from 'lodash';
import PortfolioAccountsStatsCard from 'src/components/PortfolioPage/PortfolioAccountsSubPage/PortfolioAccountsStatsCard';
import PortfolioAccountsTableSection from 'src/components/PortfolioPage/PortfolioAccountsSubPage/PortfolioAccountsTableSection';

export default function PortfolioAccountsSubPage() {
	const { show } = useModal();

	const {
		totalValue,
		delegatedTotalValue,
		mainPoolTotalValue,
		isolatedPoolTotalValue,
		vaultTotalValue,
		nonDriftStakeTotalValue,
		driftStakeTotalValue,
		vaultsWithBalance,
		nonDriftIfStake,
		driftStake,
		mainPoolAccounts,
		delegatedAccounts,
		isolatedPoolAccounts,
		vaultDepositorAccounts,
	} = usePortfolioAccountsData();

	return (
		<div className="flex flex-col gap-y-2xl pb-2xl">
			<PortfolioAccountsStatsCard
				totalValue={totalValue}
				delegatedTotalValue={delegatedTotalValue}
				mainPoolTotalValue={mainPoolTotalValue}
				isolatedPoolTotalValue={isolatedPoolTotalValue}
				vaultTotalValue={vaultTotalValue}
				nonDriftStakeTotalValue={nonDriftStakeTotalValue}
				driftStakeTotalValue={driftStakeTotalValue}
			/>

			<PortfolioAccountsTableSection
				title="Main Accounts"
				titleEndElement={
					<Button
						size="md"
						variant="secondary"
						rightIcon={Add}
						onClick={() => show({ type: 'new_subaccount', props: {} })}
						dataTestId="portfolio-add-account-button"
					>
						Add Account
					</Button>
				}
			>
				<AccountsTable accounts={mainPoolAccounts} />
			</PortfolioAccountsTableSection>

			{isolatedPoolAccounts.length > 0 && (
				<PortfolioAccountsTableSection title="Isolated Pool Accounts">
					<AccountsTable accounts={isolatedPoolAccounts} />
				</PortfolioAccountsTableSection>
			)}

			{delegatedAccounts.length > 0 && (
				<PortfolioAccountsTableSection title="Managed Accounts">
					<AccountsTable accounts={delegatedAccounts} variant="delegate" />
				</PortfolioAccountsTableSection>
			)}

			{vaultsWithBalance.length > 0 && (
				<PortfolioAccountsTableSection title="Strategy Vaults">
					<MyVaultPositionsContent
						type="my_positions"
						targetVaultManager="All"
						targetDepositAsset="All"
						targetApyPeriod="90d"
						vaultDepositorAccounts={vaultDepositorAccounts}
						sortType="apy"
						setSortType={noop}
						noClosedPositions
						isPortfolioPage
					/>
				</PortfolioAccountsTableSection>
			)}

			{nonDriftIfStake.length > 0 && (
				<PortfolioAccountsTableSection title="Insurance Fund Vaults">
					<InsuranceFundList
						filter={(data) =>
							data.marketIndex !== DRIFT_TOKEN_BANK_INDEX &&
							data.yourBalanceBase > 0
						}
						isPortfolioPage
						noTitle
					/>
				</PortfolioAccountsTableSection>
			)}

			{driftStake.length > 0 && (
				<PortfolioAccountsTableSection title="DRIFT Staking">
					<InsuranceFundList
						filter={(data) =>
							data.marketIndex === DRIFT_TOKEN_BANK_INDEX &&
							data.yourBalanceBase > 0
						}
						isPortfolioPage
						noTitle
					/>
				</PortfolioAccountsTableSection>
			)}
		</div>
	);
}
